import React, { useEffect, useState } from 'react';
import ActivePackersWidget from './ActivePackersWidget';
import ActivePickersWidget from './ActivePickersWidget';
import AwaitingOrdersWidget from './AwaitingOrdersWidget';
import ClockWidget from './ClockWidget';
import PaceWidget from './PaceWidget';

const REFRESH_INTERVAL_MS = 60000;
const PAGE_RELOAD_INTERVAL_MS = 20 * 60 * 1000;

function Today() {
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRefreshKey((current) => current + 1);
    }, REFRESH_INTERVAL_MS);

    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      window.location.reload();
    }, PAGE_RELOAD_INTERVAL_MS);

    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <div className="page-content today-page">
      <div className="container-fluid">
        <main className="today-grid">
          <section className="today-widget today-widget--clock">
            <ClockWidget refreshKey={refreshKey} />
          </section>

          <section className="today-widget today-widget--awaiting">
            <AwaitingOrdersWidget refreshKey={refreshKey} />
          </section>

          <div className="today-pace-stack">
            <section className="today-widget">
              <PaceWidget refreshKey={refreshKey} stage="picking" />
            </section>
            <section className="today-widget">
              <PaceWidget refreshKey={refreshKey} stage="packing" />
            </section>
            <section className="today-widget">
              <PaceWidget refreshKey={refreshKey} stage="shipping" />
            </section>
          </div>

          <div className="today-activity-stack">
            <section className="today-widget today-widget--active-pickers">
              <ActivePickersWidget refreshKey={refreshKey} />
            </section>

            <section className="today-widget today-widget--active-packers">
              <ActivePackersWidget refreshKey={refreshKey} />
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Today;
